
// @material-ui/icons
import Attachment from "@material-ui/icons/AttachFile";
import Book from "@material-ui/icons/ClassOutlined";
import Courses from "@material-ui/icons/TocOutlined";
import Dashboard from "@material-ui/icons/Dashboard";
import Face from "@material-ui/icons/FaceOutlined";
import Product from "@material-ui/icons/Store";
import Receipt from "@material-ui/icons/Receipt";
import School from "@material-ui/icons/LocationCityOutlined";
import Subject from "@material-ui/icons/Subject";
import Task from "@material-ui/icons/AssignmentTurnedIn";
import Teacher from "@material-ui/icons/AssignmentInd";
import Video from "@material-ui/icons/Videocam";

// core components/views
import LoginPage from "views/LoginPage/LoginPage.jsx";

import DashboardPage from "views/Dashboard/Dashboard.jsx";
import BlogPostList from "views/BlogPostList/BlogPostList.jsx";
import ClassList from "views/ClassList/ClassList.jsx";
import CourseList from "views/CourseList/CourseList.jsx";
import LessonList from "views/LessonList/LessonList.jsx";
import OrdersList from "views/OrdersList/OrdersList.jsx";
import ProductsList from "views/ProductsList/ProductsList.jsx";
import SchoolList from "views/SchoolList/SchoolList.jsx";
import StudentList from "views/StudentList/StudentList.jsx";
import SupportMaterial from "views/SupportMaterial/SupportMaterial.jsx";
import TaskList from "views/TaskList/TaskList.jsx";
import TeacherList from "views/TeacherList/TeacherList.jsx";
import VideosList from "views/VideosList/VideosList.jsx";

var dashboardRoutes = [
  
  {
    path: "/",
    sidebarName: "Dashboard",
    navbarName: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    admin: true
  },
  /*
  {
    path: "/purchases",
    sidebarName: "Purchases List",
    navbarName: "Purchases List",
    icon: "content_paste",
    component: PurchaseList
  },
  */
  {
    path: "/tasks",
    sidebarName: "Tasks",
    navbarName: "Tasks",
    icon: Task,
    component: TaskList
  },
  {
    path: "/orders",
    sidebarName: "Orders",
    navbarName: "Orders",
    icon: Receipt,
    component: OrdersList,
    isAdminOnly: false
  },
  {
    path: "/products",
    sidebarName: "Products List",
    navbarName: "Products List",
    icon: Product,
    component: ProductsList
  },
  {
    path: "/courses",
    sidebarName: "Courses",
    navbarName: "Courses List",
    icon: Courses,
    component: CourseList,
    admin: true
  },
  {
    path: "/lessons",
    sidebarName: "Lessons",
    navbarName: "Lesson List",
    icon: Book,
    component: LessonList,
    admin: true
  },
  {
    path: "/videos",
    sidebarName: "Videos",
    navbarName: "Videos List",
    icon: Video,
    component: VideosList,
    admin: true
  },
  {
    path: "/supportMaterial",
    sidebarName: "Support",
    navbarName: "Support Material",
    icon: Attachment,
    component: SupportMaterial,
    admin: true
  },
  {
    path: "/blogposts",
    sidebarName: "Blog Posts",
    navbarName: "Blog Posts",
    icon: Subject,
    component: BlogPostList,
    isAdminOnly: true
  },
  {
    path: "/classes",
    sidebarName: "Classes",
    navbarName: "Class List",
    icon: "content_paste",
    component: ClassList,
    admin: false
  },/*
  {
    path: "/maps",
    sidebarName: "Locations Map",
    navbarName: "Map",
    icon: LocationOn,
    component: Maps
  },*/
  {
    path: "/students",
    sidebarName: "Students",
    navbarName: "Students",
    icon: Face,
    component: StudentList,
    admin: false
  },
  {
    path: "/staff",
    sidebarName: "Staff",
    navbarName: "School Staff",
    icon: Teacher,
    component: TeacherList,
    admin: false
  },
  {
    path: "/schools",
    sidebarName: "Schools",
    navbarName: "Schools",
    icon: School,
    component: SchoolList,
    admin: false
  },/*
  {
    path: "/org",
    sidebarName: "District",
    navbarName: "District",
    icon: District,
    component: OrganizationPage,
    admin: false
  },
  {
    path: "/user",
    sidebarName: "User Profile",
    navbarName: "Profile",
    icon: Person,
    component: UserProfile,
    admin: false
  },
  {
    path: "/stripe",
    sidebarName: "Stripe",
    navbarName: "Stripe",
    icon: CreditCard,
    component: Stripe
  },*/
  {
    path: "/login",
    sidebarName: "Logout",
    navbarName: "Login",
    icon: Dashboard,
    component: LoginPage,
    admin: false
  }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx